<template>
  <EditorButton :title="$t('font_family')" class="rich-editor-button">
    <template v-slot:trigger="{ hide, show }">
      <FlotoDropdownPicker
        :options="options"
        :value="value"
        @change="handleOptionSelected"
      >
        <template v-slot:menu-item="{ item: option, selectItem }">
          <div
            class="dropdown-item flex items-center"
            href="javascript:;"
            @click.stop="selectItem(option)"
          >
            <span
              class="ml-2 text-ellipsis"
              :style="`display: block; font-family:${option.key}`"
            >
              {{ option.text }}
            </span>
          </div>
        </template>
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="small-icon-button"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
      </FlotoDropdownPicker>
    </template>
  </EditorButton>
</template>

<script>
import { DEFAULT_FONT_FAMILY } from './plugins/font-family'
import EditorButton from './editor-button'
export default {
  name: 'FontFamilyButton',
  components: { EditorButton },
  props: {
    value: { type: String, default: undefined },
  },
  computed: {
    options() {
      const o = DEFAULT_FONT_FAMILY
      return o
    },
  },
  methods: {
    handleOptionSelected(key) {
      this.$emit('change', key)
    },
  },
}
</script>
